
export default {
  props: {
    file: {
      type: null,
      required: true
    }
  },

  computed: {
    extension () {
      if (this.file.fileName) { return this.file.fileName.split('.').pop(); }

      if (this.file.name) { return this.file.name.split('.').pop(); }

      if (this.file.blobPath ?? this.file.blobUrl) {
        let blobPath = this.file.blobPath ?? this.file.blobUrl;
        if (!blobPath.startsWith('http')) {
          // we don't care about the base url, but it is required when using parsing a link without a host.
          const url = new URL('/' + blobPath, 'https://platform.altura.io/');
          blobPath = url.pathname;
        } else { blobPath = new URL(blobPath).pathname; }

        return blobPath.split('.').pop();
      }

      return '?';
    }
  }
};
